import { render, staticRenderFns } from "./view-actividad-detalle-simple.vue?vue&type=template&id=739cd3ad"
import script from "./view-actividad-detalle-simple.vue?vue&type=script&lang=js"
export * from "./view-actividad-detalle-simple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports